import { render } from "./IconCard.vue?vue&type=template&id=36a62ca4"
import script from "./IconCard.vue?vue&type=script&lang=js"
export * from "./IconCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36a62ca4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36a62ca4', __exports__)) {
    api.reload('36a62ca4', __exports__)
  }
  
  module.hot.accept("./IconCard.vue?vue&type=template&id=36a62ca4", () => {
    api.rerender('36a62ca4', render)
  })

}


export default __exports__